import React, { useRef } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '/styles/pstlandingpage.module.scss'
import CustomImage from "../CustomImage"; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface Props {
    data: any
}
const GloballyUniversities: React.FC<Props> = ({ data }) => {
    const sliderRef = useRef<Slider>(null);

    const settings = {
        dotsClass: styles.sliderDots,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 3,
        slidesPerRow: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 2,
                    slidesPerRow: 2,
                }
            }
        ]
    };
    return (
        <div className={styles.uni}>
            <Container>
                <Row className="text-center">
                    <div>
                        <h2>{data?.sectionTitle}</h2>
                        <h5 className="mb-4">{data?.sectionDescription}</h5>
                    </div>
                </Row>
                <Row>
                    <div className={styles.sliderdiv}>
                        <Slider {...settings} className={styles.slider} ref={sliderRef}>
                            {
                                data?.universityImages?.length > 0
                                    ? data?.universityImages.map((university: any) => {
                                        return (
                                            <div>
                                                <div className={styles.logo}>
                                                    <CustomImage src={university?.imageUrl || "/images/uni-logo/manitoba.svg"} alt={university?.alt} width={321} height={132} className={styles.img} />
                                                </div>
                                            </div>
                                        )
                                    })
                                    : 'No Universities'
                            }

                        </Slider>
                        <div className={styles.arrowsClass}>
                            <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()} >
                                <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                            </div>
                            <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                                <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                            </div>
                        </div>
                    </div>
                </Row>
            </Container>
        </div>
    )
}
export default GloballyUniversities